import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
var FcSendEmailMessageDialogComponent = /** @class */ (function () {
    function FcSendEmailMessageDialogComponent(ref, data) {
        this.ref = ref;
        this.data = data;
        this.title = this.data.title;
        this.message = this.data.message;
        this.okText = this.data.okText;
        this.notOkText = this.data.notOkText;
        this.cancelText = this.data.cancelText;
        this.inputLabel = this.data.inputLabel;
    }
    FcSendEmailMessageDialogComponent.prototype.ngOnInit = function () {
    };
    FcSendEmailMessageDialogComponent.prototype.confirm = function () {
        this.ref.close({
            sendEmail: true,
            message: this.inputValue
        });
    };
    FcSendEmailMessageDialogComponent.prototype.notConfirm = function () {
        this.ref.close({
            sendEmail: false,
        });
    };
    return FcSendEmailMessageDialogComponent;
}());
export { FcSendEmailMessageDialogComponent };
